"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _KYC_IMFormStepComponent = _interopRequireDefault(require("./KYC_IMFormStepComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    formValues: (0, _reduxForm.getFormValues)('kycIMForm')(state)
  };
};
var KYCIdentityMindFormStepForm = (0, _reduxForm.reduxForm)({
  form: 'kycIMForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(_KYC_IMFormStepComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(KYCIdentityMindFormStepForm);